<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div>
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Next card expiries</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="list">
        <mat-table [dataSource]="list">
          <ng-container matColumnDef="cardToken">
            <mat-header-cell *matHeaderCellDef>Token</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{ card.cardToken }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="customer">
            <mat-header-cell *matHeaderCellDef>Customer</mat-header-cell>
            <mat-cell *matCellDef="let card">
              <a style="text-decoration: none;" [routerLink]="'../../../customers-overview/' + card.customerId"><mat-icon>visibility</mat-icon> {{card.customerFirstname}} {{card.customerLastname}}</a>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="product">
            <mat-header-cell *matHeaderCellDef>Product</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{card.productName}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="dueDate">
            <mat-header-cell *matHeaderCellDef>Expiry Date</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{card.expireDate  | date: "dd.MM.yyyy"}} </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <mat-header-row *matHeaderRowDef="['cardToken', 'customer', 'product', 'dueDate']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['cardToken', 'customer', 'product', 'dueDate']"></mat-row>
        </mat-table>

      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
